export default () => {
  const formatData = (
    {
      processed_address_formatted,
      geo_process_pinned,
      neighborhood_name,
      city_id,
      city_name,
      sub_category_name,
      common_area,
      built_area,
      private_area,
      terrain_area,
      floor,
      total_area,
      useful_area,
      bedroom,
      garage,
      suite,
      negative_goodwill,
      created_at,
      auction_date,
      first_auction_value,
      first_auction_date,
      second_auction_value,
      second_auction_date,
      last_value,
      value,
      neighborhood_id,
      closure_date,
      closed,
      is_occupied,
      url,
      processed_address_zip_code,
      documents_list,
      sub_category_id,
      location,
      city_uf,
      seller,
      rated_value,
      updated_at,
    },
    id,
  ) => {
    const price = last_value
    const date = updated_at || created_at
    return {
      Id: id,
      IsAudit: true,
      Seller: seller || '',
      Closed: closed || '',
      ClosureDate: closure_date || '',
      ClosureValue: value,
      Suite: suite || '',
      AuctionDate: auction_date || '',
      RatedValue: rated_value || '',
      IsOccupied: is_occupied === undefined ? '' : is_occupied,
      DocumentsList: documents_list,
      FirstAuctionValue: first_auction_value || '',
      FirstAuctionDate: first_auction_date || '',
      SecondAuctionValue: second_auction_value || '',
      SecondAuctionDate: second_auction_date || '',
      NegativeGoodwill: negative_goodwill,
      AdDate: date,
      Address: processed_address_formatted || '',
      Bedrooms: bedroom >= 0 ? bedroom : '',
      Category: sub_category_name || '',
      CategoryId: sub_category_id || '',
      Cep: processed_address_zip_code || '',
      City: city_name || '',
      CityId: city_id || '',
      Uf: city_uf || '',
      Garages: garage >= 0 ? garage : '',
      Link: url || '',
      MeterPrice:
        (price &&
          total_area &&
          (price / total_area).toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })) ||
        '',
      Neighborhood: neighborhood_name || '',
      NeighborhoodId: neighborhood_id || '',
      Price:
        price.toLocaleString('pt-BR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }) || '',
      TotalArea: total_area || '',
      UsefulArea: useful_area || '',
      UsefulMeterPrice:
        (price &&
          useful_area &&
          (price / useful_area).toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })) ||
        '',
      Mapped: geo_process_pinned || '',
      location,
    }
  }
  const formatValuated = ({ hits }) =>
    hits.map(item =>
      formatData(item._source || item, item._id || item.link_key || item.id),
    )

  // eslint-disable-next-line no-restricted-globals
  self.addEventListener('message', event => {
    if (!event || !event.data) return
    const { data } = event
    const result = formatValuated(data)
    postMessage(result)
  })
}
